var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RplForm',{staticClass:"search-form",attrs:{"formData":_vm.updatedFormData,"submitHandler":_vm.getSearchResults,"scrollToMessage":false}})}
var staticRenderFns = []

export { render, staticRenderFns }